import AppForm from '@/components/AppForm';
import AppPageTitle from '@/components/AppPageTitle';
import PATH from '@/config/paths/PATH';
import useFormSubmit from '@/hooks/useFormSubmit';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import useMission from '@/redux/hooks/useMission';
import { updateMission } from '@/services/mission.service';
import { formatNumber } from '@/utils/formatters';
import { useMutation } from '@tanstack/react-query';
import { Checkbox, Col, Form, Input, InputNumber, Row, Select, Space, Switch } from 'antd';
import _ from 'lodash';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

function MissionUpdate() {
  const [form] = Form.useForm();
  const missionType = Form.useWatch('type_mission', form);
  const { mission, clearMission } = useMission();
  const navigate = useNavigate();
  const initialValues = useMemo(() => {
    if (!mission) return {};
    return {
      ...mission,
      is_active: mission.is_active === 1 ? true : false,
    };
  }, [mission]);

  const missionMutation = useMutation({
    mutationFn: updateMission,
  });

  const handleOnSubmit = useFormSubmit(
    missionMutation,
    (values) => ({
      ...values,
      is_active: values.is_active ? 1 : 2,
      id: initialValues?.id,
    }),
    {
      onOk: async () => {
        await clearMission();
        navigate(PATH.MISSIONS.ROOT, {
          replace: true,
        });
      },
    }
  );

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  if (!mission) return null;

  return (
    <Space direction="vertical" className="w-full">
      <AppPageTitle title="Update Mission" />

      <AppForm
        form={form}
        initialValues={initialValues}
        onSubmit={handleOnSubmit}
        buttonProps={{
          loading: missionMutation.isPending,
          disabled: missionMutation.isPending,
        }}
        targetPath={PATH.MISSIONS.ROOT}
        disabled={missionMutation.isPending}
      >
        <Row gutter={24}>
          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Mission Name (En)"
              name="name_en"
              rules={[{ required: true, message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
            <Form.Item
              label="Mission Name (My)"
              name="name_my"
              rules={[{ required: true, message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>

            <Form.Item
              label="Cycle (day)"
              name="cycle"
              rules={[{ required: true, message: 'Please enter cycle' }]}
            >
              {/* <Input type="number" placeholder="Enter cycle" /> */}
              <InputNumber placeholder="Enter cycle" className="w-full" addonAfter="day" />
            </Form.Item>

            <Form.Item
              label="Action"
              name="action"
              rules={[{ required: true, message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
          </Col>

          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Number mission"
              name="number_mission"
              rules={[{ required: true, message: 'Please enter number mission' }]}
            >
              <InputNumber
                className="w-full"
                placeholder="Enter number mission"
                formatter={(value) => {
                  if (!value) return value;
                  return formatNumber(value);
                }}
                parser={(value) => {
                  if (!value) return value;
                  return value.replace(/\$\s?|(,*)/g, '');
                }}
              />
            </Form.Item>
            {/* <Form.Item
              label="Turn of Cycle"
              name="nameEnglish"
              rules={[{ message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item> */}
            {!_.includes(mission.action, 'LOGIN_STREAK') ? (
              <Form.Item
                label="Heart"
                name="heart"
                rules={[{ required: true, message: 'Please enter heart' }]}
              >
                <InputNumber
                  className="w-full"
                  placeholder="Enter heart"
                  formatter={(value) => formatNumber(value)}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
              </Form.Item>
            ) : (
              <>
                <Form.Item
                  label="Award Heart"
                  name="heart"
                  // rules={[{ required: true, message: 'Please enter heart' }]}
                >
                  <InputNumber
                    className="w-full"
                    placeholder="Enter heart"
                    formatter={(value) => formatNumber(value)}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                  />
                </Form.Item>
                <Form.Item
                  label="Award Point"
                  name="point"
                  // rules={[{ required: true, message: 'Please enter point' }]}
                >
                  <InputNumber
                    className="w-full"
                    placeholder="Enter point"
                    formatter={(value) => formatNumber(value)}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                  />
                </Form.Item>
                <Form.Item
                  label="Award Key"
                  name="total_key"
                  // rules={[{ required: true, message: 'Please enter point' }]}
                >
                  <InputNumber
                    className="w-full"
                    placeholder="Enter point"
                    formatter={(value) => formatNumber(value)}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                  />
                </Form.Item>
                <Form.Item
                  label="Mission Type"
                  name="type_mission"
                  rules={[{ required: true, message: 'Please select mission type' }]}
                >
                  <Select placeholder="Select mission type">
                    <Select.Option value={1}>1 - Add Heart</Select.Option>
                    <Select.Option value={2}>2 - Add Point</Select.Option>
                    <Select.Option value={3}>3 - Add Key</Select.Option>
                    <Select.Option value={4}>4 - Other (example: Heart end Key...)</Select.Option>
                  </Select>
                </Form.Item>

                {missionType === 4 && (
                  <Form.Item
                    label="Special Mission"
                    name="is_special"
                    valuePropName="checked"
                    initialValue={false}
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                )}
              </>
            )}

            <Form.Item label="Active" name="is_active" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </AppForm>
    </Space>
  );
}

export default MissionUpdate;
